/** Mesmas lojas referenciadas em https://govfacil.app/ */
export const GOV_APP_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.govfacil'
// export const GOV_APP_PLAY_URL = 'https://play.google.com/store/apps/developer?id=GovF%C3%A1cil';


export const GOV_APP_STORE_URL = 'https://apps.apple.com/br/app/govf%C3%A1cil-app/id1552229116'
// export const GOV_APP_STORE_URL = 'https://apps.apple.com/br/developer/govfacilbrasil-tecnologia-e-gestao-ltda/id1450973466';

export function useCadastreSucesso() {
    return {
        playStoreUrl: GOV_APP_PLAY_URL,
        appStoreUrl: GOV_APP_STORE_URL,
    };
}
